<template>
	<div class="cm-list-item skeleton">
		<div class="card">
			<div class="row no-gutters">
				<div class="item-img col col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
					<div class="m-2">
						<div class="skeleton-block ratio ratio-6x4"></div>
					</div>
				</div>
				<div
					class="item-body col-item-body col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8"
				>
					<div class="row no-gutters h-100">
						<div class="item-content col-9 col-md-9 col-xl-9 col-lg-9">
							<div class="cm-list-item-body ps-xl-2 ps-lg-2 ps-md-2">
								<div class="skeleton-block h-4 w-100 mb-4"></div>

								<div class="row gx-2 gy-1 feature-list mb-3">
									<div class="col-6 col-lg-4 no-wrap text-truncate">
										<div class="skeleton-block h-3 w-90 mb-1"></div>
									</div>
									<div class="col-6 col-lg-4">
										<div class="skeleton-block h-3 w-90 mb-1"></div>
									</div>
									<div class="col-6 col-lg-4">
										<div class="skeleton-block h-3 w-90 mb-1"></div>
									</div>
									<div class="col-6 col-lg-4">
										<div class="skeleton-block h-3 w-90 mb-1"></div>
									</div>
								</div>
							</div>
						</div>
						<div class="item-pricing col-3 col-md-3 col-xl-3 col-lg-3">
							<div class="cm-list-item-pricing">
								<div class="item-price pt-2">
									<div
										class="d-flex justify-content-end w-100 flex-column text-end"
									>
										<div class="d-flex justify-content-end">
											<p class="skeleton-block d-block h-2 w-60 mb-2"></p>
										</div>
										<div class="d-flex justify-content-end">
											<p class="skeleton-block d-block h-5 w-40 mb-2"></p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div
							class="item-body-bottom ms-auto col-12 ps-xl-2 ps-lg-2 ps-md-2"
						>
							<div class="w-100 subtext">
								<div class="skeleton-block h-2 w-20 my-1"></div>
							</div>
						</div>
						<div class="col-12 align-self-end">
							<div class="item-footer align-self-end bg-lighter w-100">
								<div class="row g-0 align-items-center">
									<div
										class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5 text-center text-sm-start"
									></div>
									<div
										class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-7 p-1"
									>
										<div class="row g-2 g-md-2">
											<div class="col-12 col-sm-6 col-md-6 col-lg-6 text-end">
												<div class="skeleton-block h-4 w-100 mb-0"></div>
											</div>
											<div class="col-12 col-sm-6 col-md-6 col-lg-6">
												<div class="skeleton-block h-4 w-100 mb-0"></div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ListItemSkeleton',
}
</script>
